var map = {
	"./3d-glasses-1.png": 270,
	"./3d-glasses-2.png": 271,
	"./3d-glasses-3.png": 272,
	"./3d-glasses-4.png": 273,
	"./action-cam-1.png": 274,
	"./action-cam-2.png": 275,
	"./action-cam-3.png": 276,
	"./action-cam-4.png": 277,
	"./ecommerce-product-img-1.png": 278,
	"./ecommerce-product-img-2.png": 279,
	"./portable-speaker-1.png": 280,
	"./portable-speaker-2.png": 281,
	"./portable-speaker-3.png": 282,
	"./speaker-1.png": 283,
	"./speaker-2.png": 284,
	"./speaker-3.png": 285,
	"./watch-1.png": 286,
	"./watch-2.png": 287,
	"./watch-3.png": 288,
	"./watch-4.png": 289,
	"./watch-card.png": 290,
	"./white-cam-1.png": 291,
	"./white-cam-2.png": 292,
	"./white-cam-3.png": 293,
	"./white-cam-4.png": 294,
	"./white-cam-card.png": 295,
	"./wifi-1.png": 296,
	"./wifi-2.png": 297,
	"./wifi-3.png": 298,
	"./wireless-bluetooth-1.png": 299,
	"./wireless-bluetooth-2.png": 300,
	"./wireless-bluetooth-3.png": 301,
	"./wireless-bluetooth-4.png": 302,
	"./x-box-image-detail-1.png": 303,
	"./x-box-image-detail-2.png": 304,
	"./x-box-image-detail-3.png": 305,
	"./x-box-image-detail-4.png": 306,
	"./xbox-1.png": 307,
	"./xbox-2.png": 308,
	"./xbox-3.png": 309,
	"./xbox-4.png": 310,
	"./xbox-black.png": 311,
	"./xbox-blue.png": 312,
	"./xbox-red.png": 313,
	"./xbox-white.png": 314
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 269;